import "./MemberLogin4.module.css";
import Header from "@/reusable_sections/Header";
import MemberLogin from "./sections/MemberLogin";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function MemberLogin4Page() {
  return <div>
      <Header />
      <MemberLogin />
      <Benefits />
      <Footer />
    </div>;
}